import { unref } from 'vue';
import { Form } from '@src/form/composables/form.js';

export function useFormComposable<onSubmitReturnType = void|null>(formData: { [key: string]: any }, onSubmit: () => onSubmitReturnType|null = () => null) {
    const form = new Form(unref(formData), onSubmit);

    return {
        form,
        exposes: {
            reset: () => form.reset(),
            submit: () => {
                return Promise.resolve(form.submit());
            },
        },
    };
}
